import { createReducer, createAction } from '@reduxjs/toolkit';

import { ISnackbarState } from 'src/components/common/types/snackbarTypes';

export const showSnackbar = createAction<ISnackbarState>('SHOW_SNACKBAR');
export const hideSnackbar = createAction('HIDE_SNACKBAR');

const initialState: ISnackbarState = {
	message: '',
	severity: 'info',
	open: false,
	id: null,
	position: 'right',
};

export const snackbarReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(showSnackbar, (state, action) => {
			return { ...action.payload, open: true };
		})
		.addCase(hideSnackbar, (state) => {
			state.open = false;
		});
});
